import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../Theme';
import { Heading3 } from '../ui/text/Heading3';
import Image from '@jetshop/ui/Image';
import { ReactComponent as R } from '../../svg/R.svg';
import { Link } from 'react-router-dom';

const SubCategoryNavigationWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 30px 0;
  margin-bottom: 30px;
  border-bottom: 1px solid ${theme.colors.border};
  grid-gap: 20px;
`;

const SubcategoryWrapper = styled('div')`
  max-width: 135px;
  h3 {
    font-size: 16px;
    line-height: 17px;
  }
  a {
    text-decoration: none;
  }
`;

const ImageWrapper = styled('div')`
  width: 135px;
  height: 135px;
  margin-bottom: 10px;
  background: ${theme.colors.lightgrey};

  img {
    mix-blend-mode: multiply;
  }
`;

const MissingImage = styled('div')`
  background: #f7f5f3;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 40px;
    height: 40px;
  }
`;

export const SubCategoryNavigation = ({ subcategories }) => {
  if (subcategories?.length < 1) {
    return null;
  }

  return (
    <SubCategoryNavigationWrapper>
      {subcategories.map(subcategory => {
        return (
          <SubcategoryWrapper key={subcategory?.id}>
            <Link to={subcategory?.primaryRoute?.path}>
              <ImageWrapper>
                {subcategory?.images?.length > 1 ? (
                  <Image
                    src={subcategory?.images[0]?.url}
                    aspect={'1:1'}
                    cover
                  />
                ) : (
                  <MissingImage>
                    <R />
                  </MissingImage>
                )}
              </ImageWrapper>
              <Heading3 text={subcategory.name} />
            </Link>
          </SubcategoryWrapper>
        );
      })}
    </SubCategoryNavigationWrapper>
  );
};
